import client from "../graphqlClient";
import { getGraphqlResult } from "../../Utilities/Functions";
import { SEARCH_AUDIT_RECORD, GET_AUDIT_BY_ENTITY_ID } from "./graphql";

const searchAuditRecords = async variables => {
  const response = await client.query({
    query: SEARCH_AUDIT_RECORD,
    fetchPolicy: "network-only",
    variables,
  });

  const results = await getGraphqlResult(response, "searchAuditRecords");
  return results;
};

const getEntityAuditRecords = async variables => {
  const response = await client.query({
    query: GET_AUDIT_BY_ENTITY_ID,
    fetchPolicy: "network-only",
    variables,
  });

  const results = await getGraphqlResult(response, "getEntityAuditRecords");
  return results;
};
export { searchAuditRecords, getEntityAuditRecords };
